import {fetchJSON} from "../utils/fetch";
import {Service, service, inject} from "./di";
import {ConfigService} from "./ConfigService";
import MetadataService from "./MetadataService";
import {Backflipp} from "./BackflippService";
import {LocationService} from "./LocationService";
import {FlyerService} from "./FlyerService";
import {slugify} from "../utils/slugify";
import { FlyerMetadataJSON } from "../definitions/BackflippDefinitions";

@service
export default class MerchantService extends Service {
	@inject configService: ConfigService;
	@inject metadataService: MetadataService;
	@inject backflippService: Backflipp;
	@inject flyerService: FlyerService;
	@inject locationService: LocationService;

	public async getMerchantAndFlyers(locale: string, merchantName: string) {
		const uri = `/amp/merchant/${merchantName}/flyers/${locale}`;
		const data = await fetchJSON(this.configService.SSR_RENDERER + uri);
		return data;
	}

	public async getMerchantFlyersInLocation(merchantName: string): Promise<FlyerMetadataJSON[]> {
		const flyersData = await this.flyerService.getFlyersDataJSON(this.locationService.postalCode);
		return flyersData.flyers.filter(flyer => slugify(flyer.merchant) === merchantName);
	}

	/**
	 * Takes the category with the most flyers and returns only premium flyers
	 * If there is not premium in the top, it takes the next category
	 */
	public async getTopCategoryPremiumFlyers(): Promise<FlyerMetadataJSON[]> {
		const { flyers } = await this.flyerService.getFlyersDataJSON(this.locationService.postalCode);
		const categories = await this.flyerService.getCategories();
		const sortedCategories = [...categories].sort((a, b) => a.count - b.count).slice(0, categories.length - 2);
		let filteredFlyers: FlyerMetadataJSON[] = [];
		while (filteredFlyers.length === 0 && sortedCategories.length > 0) {
			const topCategory = sortedCategories.pop();
			filteredFlyers = flyers.filter(flyer => flyer.categories.includes(topCategory.name) && flyer.premium === true);
		}
		return filteredFlyers;
	}
}
